import JSONPointerError from "./JSONPointerError.mjs";
class JSONPointerParseError extends JSONPointerError {}
export default JSONPointerParseError;